export default "__VITE_ASSET__e689eb97__"